import Carousel from './components/index/Carousel'
import News from './components/index/News'
import HotGames from './components/index/HotGames'
import Contact from './components/index/Contact'
import styles from './Index.module.less'
import Banner from '@/pages/components/common/Banner'

function Index({ history }) { 
  return (
    <>
      <Banner />
      <div className={`mod ${styles.mainMod}`}>
        <div className={styles.item}><Carousel /></div>
        <div className={styles.item}><News /></div>
      </div>
      <HotGames />
      <Contact />
    </>
  );
}

export default Index;
